
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { editCashCard,getChargeCardDetail, } from "@/api/api-non-name";
import { checkCardInfo} from "@/api/api-operation-service";
import { getCountryCodeList } from "@/api/api-basic";
import i18n from "@/config/i18n";
import regular from "@/common/regular";
import validate from "@/common/regular";
@Component({
  components: {}
})
export default class PiHairpinManage extends Vue {
  private FormData: objAny = {};
   private ruleInline = {
    cardPhysicalNumber: [
      {
        required: true,
        validator: validate.abcNumber,
        trigger: "change",
        name: i18n.t("nonRealNameCardManagement.cardPhysicalNumber"),
        min: 1,
        max: 20
      }
    ],
    silkScreenNumber: [
      {
        required: true,
        name: i18n.t("nonRealNameCardManagement.silkScreenNumber"),
        trigger: "change",
        validator: validate.abcNumber,
        min: 1,
        max: 20
      }
    ],
    contactName: [
      {
        required: true,
        message: i18n.t("regular.please"),
        trigger: "change"
      }
    ],
    identityCardNumber: [
      {
        required: true,
        message: i18n.t("regular.please"),
        trigger: "change"
      }
    ],
    email: [
      {
        required: true,
        validator: regular.emailRegular,
        trigger: "change"
      }
    ],
    times: [
      {
        required: true,
        type: "array",
        message: i18n.t("formText.selectTimePl"),
        trigger: "change"
      }
    ],
    chargingTime: [
      {
        required: true,
        name: i18n.t("nonCard.chargingHours"),
        trigger: "change",
        max: 24,
        min: 0.01,
        validator: regular.money
      }
    ],
    phoneNo: [
      {
        required: false,
        name: i18n.t("nonRealNameCardManagement.phone"),
        validator: (rule: any, value: string, callback: any) => {
          console.log(rule);
          const reg = /^[0-9]{6,15}$/;
          if (!this.formInline.countryCode && !value) {
            callback();
          } else if (value === "") {
            callback(new Error(i18n.t("regular.phonePl") + ""));
          } else if (!reg.test(value)) {
            callback(new Error(i18n.t("regular.phoneError") + ""));
          } else {
            callback();
          }
        },
        trigger: "blur"
      }
    ]
  };

  private email = ''
  private isMember = false
  private formInline: objAny = {
    cardPhysicalNumber: "",
    // cardSerialNumber: "",
    contactName: "",
    money: "0",
    memberType:0,
    phoneNo: "",
    identityCardNumber: "",
    countryCode:'',
    silkScreenNumber: "",
    cardType: "3",
    times: [],
    effectiveBeginTime: "",
    effectiveEndTime: ""
  };
    // 获取电话区号
  public codeList: any = [];
  async getCodeList() {
    const res = await getCountryCodeList();
    if (res.status === this.$config.apiStatus) {
      this.codeList = res.data || [];
    }
  }
  private timeChange(value: string[]): void {
    this.formInline.effectiveBeginTime = value[0];
    this.formInline.effectiveEndTime = value[1];
  }
  private openLoading = false;
  async editCard() {

    const ret = await editCashCard({...this.formInline});
    if (ret.status === this.$config.apiStatus) {
      if (!ret || !ret.data) {
        return;
      }

      this.$Message.success(i18n.t("updateSuccess"));
      setTimeout(() => {
        this["$router"].push(
          "/member-management/non-real-name-card-management"
        );
      }, 1000);
    }
  }

  async validEmail(): Promise<void> {
    if(this.email === this.formInline.email) {
      this.editCard();
      return
    }
    const res = await checkCardInfo({ email: this.formInline.email });
    if (res?.data?.length) {
      const { registerFlag, bindFlag } = res.data[0];

      if (bindFlag) {
        this.$Modal.error({
          title: i18n.t("saveFailed") + "",
          content: i18n.t("emailBandTips") + "",
          okText: i18n.t("confirm") + "",
          onOk: async () => {}
        });
        return;
      }

      if (!registerFlag) {
        this.$Modal.confirm({
          title: i18n.t("confirm") + "",
          content: i18n.t("emailNoRegTips") + "",
          okText: i18n.t("confirm") + "",
          onOk: async () => {
            this.editCard();
          }
        });
        return;
      }

      this.editCard();
    }
  }
  public handleSubmit() {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.validEmail();
      }
    });
  }
  async getChargeCardDetails (cardPhysicalNumber:string){
    const res  = await getChargeCardDetail({cardPhysicalNumber,cardSerialNumber:cardPhysicalNumber})
    if(res?.data?.length){
      const data = res.data[0]
      this.isMember = data.memberType == 1
      data.times=[data.effectiveBeginTime,data.effectiveEndTime]
      this.email = data.email
      this.formInline = data
    }
  }
  mounted() {
    this.getCodeList()
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formInline"];
      });
    }

    const data = this["$common"].get("non-real-name-card-management-item");
    this.getChargeCardDetails(data.cardPhysicalNumber)

}
